import { render, staticRenderFns } from "./Invoices.vue?vue&type=template&id=0255ba5e&scoped=true&"
import script from "./Invoices.vue?vue&type=script&lang=js&"
export * from "./Invoices.vue?vue&type=script&lang=js&"
import style0 from "./Invoices.vue?vue&type=style&index=0&id=0255ba5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0255ba5e",
  null
  
)

export default component.exports